(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var statsSection = document.querySelector('.about-stats');
    if (!statsSection) return;

    var numbers = statsSection.querySelectorAll('.about-stat__number');
    var animated = false;

    function countUp(el) {
      var text = el.textContent.trim();
      var suffix = text.replace(/[\d,]/g, '');
      var target = parseInt(text.replace(/[^\d]/g, ''), 10);
      if (isNaN(target)) return;

      var duration = 1600;
      var start = 0;
      var startTime = null;

      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var ease = 1 - Math.pow(1 - progress, 3);
        var current = Math.floor(ease * target);
        el.textContent = current.toLocaleString('en-IN') + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !animated) {
          animated = true;
          numbers.forEach(function(el) { countUp(el); });
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(statsSection);

    var fadeEls = document.querySelectorAll('.about-why__card, .about-service');
    if (fadeEls.length) {
      fadeEls.forEach(function(el) { el.classList.add('will-animate'); });
      var fadeObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var siblings = Array.from(entry.target.parentElement.children);
            var delay = siblings.indexOf(entry.target) * 100;
            setTimeout(function() { entry.target.classList.add('is-visible'); }, delay);
            fadeObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
      fadeEls.forEach(function(el) { fadeObs.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-services"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var cards = document.querySelectorAll('.about-service');
    if (!cards.length) return;

    cards.forEach(function(el) { el.classList.add('will-animate'); });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var siblings = Array.from(entry.target.parentElement.children);
          var delay = siblings.indexOf(entry.target) * 100;
          setTimeout(function() { entry.target.classList.add('is-visible'); }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    cards.forEach(function(el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-stats"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var statsSection = document.querySelector('.about-stats');
    if (!statsSection) return;

    var numbers = statsSection.querySelectorAll('.about-stat__number');
    var animated = false;

    function countUp(el) {
      var text = el.textContent.trim();
      var suffix = text.replace(/[\d,]/g, '');
      var target = parseInt(text.replace(/[^\d]/g, ''), 10);
      if (isNaN(target)) return;

      var duration = 1600;
      var startTime = null;

      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var ease = 1 - Math.pow(1 - progress, 3);
        var current = Math.floor(ease * target);
        el.textContent = current.toLocaleString('en-IN') + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !animated) {
          animated = true;
          numbers.forEach(function(el) { countUp(el); });
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(statsSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-why"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var cards = document.querySelectorAll('.about-why__card');
    if (!cards.length) return;

    cards.forEach(function(el) { el.classList.add('will-animate'); });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var siblings = Array.from(entry.target.parentElement.children);
          var delay = siblings.indexOf(entry.target) * 100;
          setTimeout(function() { entry.target.classList.add('is-visible'); }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    cards.forEach(function(el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["birthday-prompt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bday-prompt]').forEach(function (el) {
      var key = el.getAttribute('data-dismiss-key');
      var dismissible = el.getAttribute('data-dismissible') === 'true';
      if (dismissible && key) {
        try {
          if (localStorage.getItem(key) === '1') { el.remove(); return; }
        } catch (e) {}
      }
      el.hidden = false;
      var closeBtn = el.querySelector('[data-bday-dismiss]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          el.hidden = true;
          if (key) { try { localStorage.setItem(key, '1'); } catch (e) {} }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bxgy-promo-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var boxes = document.querySelectorAll('.bxgy-promo');
    boxes.forEach(function (box) {
      var cdEl = box.querySelector('.bxgy-promo__countdown');
      if (!cdEl) return;

      var countdownMode = box.getAttribute('data-countdown-mode') || 'always';
      var isPeak = box.getAttribute('data-is-peak') === 'true';
      if (countdownMode === 'peak_only' && !isPeak) return;

      var validUntilRaw = box.getAttribute('data-valid-until');
      if (!validUntilRaw) return;
      var validUntil = new Date(validUntilRaw);
      if (isNaN(validUntil.getTime())) return;

      var timer = null;

      function tick() {
        var diff = validUntil.getTime() - Date.now();
        if (diff <= 0) {
          cdEl.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        function pad(n) { return n < 10 ? '0' + n : String(n); }
        cdEl.textContent = '⏱ ' + pad(h) + ':' + pad(m) + ':' + pad(s);
        cdEl.hidden = false;
      }

      tick();
      timer = setInterval(tick, 1000);
    });
  })();

  (function () {
    var boxes = document.querySelectorAll('.bxgy-promo');
    boxes.forEach(function (box) {
      var sectionId = box.getAttribute('data-section-id');
      var headlineEl = box.querySelector('.bxgy-promo__headline');
      if (!sectionId || !headlineEl) return;

      function parseJSON(attr, fallback) {
        var el = document.querySelector('[' + attr + '="' + sectionId + '"]');
        if (!el) return fallback;
        try { return JSON.parse(el.textContent) || fallback; } catch (e) { return fallback; }
      }

      var tiers = parseJSON('data-bxgy-promo-tiers', []) || [];
      var ladder = parseJSON('data-bxgy-promo-ladder', {}) || {};
      var initialLines = parseJSON('data-bxgy-promo-cart-lines', []) || [];
      if (!tiers.length) return;

      tiers = tiers.slice().sort(function (a, b) { return (a.buyMeters || 0) - (b.buyMeters || 0); });

      var eligTypes = (ladder.eligibleProductTypes || []).map(function (t) { return String(t).toLowerCase(); });
      var eligIds = (ladder.eligibleProductIds || []).map(function (g) {
        var m = String(g).match(/(\d+)\s*$/);
        return m ? m[1] : String(g);
      });

      // fractional cut pieces: SKU suffix "-2.5M" means 1 cart unit = 2.5 real meters
      function getMetersPerUnit(sku) {
        if (!sku) return 1;
        var match = /-(\d+(?:\.\d+)?)M$/i.exec(sku);
        if (!match) return 1;
        var value = Number(match[1]);
        return isFinite(value) && value > 0 ? value : 1;
      }
      function getEffectiveMeters(line) {
        return (line.quantity || 0) * getMetersPerUnit(line.sku);
      }
      function isBuyEligible(line) {
        if (!eligTypes.length && !eligIds.length) return true;
        var t = String(line.product_type || '').toLowerCase();
        if (eligTypes.indexOf(t) !== -1) return true;
        if (eligIds.indexOf(String(line.product_id)) !== -1) return true;
        return false;
      }

      // /cart.js line items don't carry the free_gift_category metafield, so live
      // updates reuse this SAME static catMap built once at init (from the initial
      // cart lines' embedded category) rather than trying to rebuild it — category
      // is a static property of a product, not something that changes between cart
      // snapshots, so this stays accurate across add/remove/qty changes.
      var catMap = {};
      initialLines.forEach(function (l) { if (l.category) catMap[String(l.product_id)] = l.category; });

      function buildRewardLines(lines, cats) {
        return lines.map(function (l, i) { return { i: i, l: l }; })
          .filter(function (e) {
            var c = catMap[String(e.l.product_id)];
            return c && cats.indexOf(c) !== -1;
          })
          .map(function (e) {
            var m = getMetersPerUnit(e.l.sku);
            return { i: e.i, quantity: e.l.quantity || 0, mpu: m, perMeter: (e.l.unit_price || 0) / m };
          })
          .sort(function (a, b) { return a.perMeter - b.perMeter; });
      }
      // cheapest-per-effective-meter-first, up to capMeters total — "can this tier's
      // full reward be given at all" allocation.
      function allocate(lines, buyIdx, cats, capMeters) {
        var rewardLines = buildRewardLines(lines, cats);
        var remaining = capMeters;
        var dualFreed = 0, freedTotal = 0;
        for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
          var rl = rewardLines[r];
          var ua = Math.floor(remaining / rl.mpu + 1e-9);
          var uf = Math.min(ua, rl.quantity);
          if (uf <= 0) continue;
          var freed = uf * rl.mpu;
          remaining -= freed;
          freedTotal += freed;
          if (buyIdx[rl.i]) dualFreed += freed;
        }
        return { freed: freedTotal, dualFreed: dualFreed };
      }
      // partial-cap allocation: non-dual donors keep being given away free up to
      // capMeters, dual-eligible donors stop once their portion hits dualBudget.
      function allocateBudgetCapped(lines, buyIdx, cats, capMeters, dualBudget) {
        var rewardLines = buildRewardLines(lines, cats);
        var remaining = capMeters;
        var dualFreed = 0, freedTotal = 0;
        for (var r = 0; r < rewardLines.length && remaining > 1e-9; r++) {
          var rl = rewardLines[r];
          var isDual = !!buyIdx[rl.i];
          var maxByDualBudget = isDual ? Math.floor(Math.max(0, dualBudget - dualFreed) / rl.mpu + 1e-9) : Infinity;
          var ua = Math.floor(remaining / rl.mpu + 1e-9);
          var uf = Math.min(ua, rl.quantity, maxByDualBudget);
          if (uf <= 0) continue;
          var freed = uf * rl.mpu;
          remaining -= freed;
          freedTotal += freed;
          if (isDual) dualFreed += freed;
        }
        return { freed: freedTotal, dualFreed: dualFreed };
      }
      function fmt(n) {
        n = Math.round(n * 10) / 10;
        return n % 1 === 0 ? String(Math.round(n)) : String(n);
      }
      function mUnit(n) { return n === 1 ? 'meter' : 'meters'; }
      function benefitHtml(tier) {
        var free = tier.freeMeters || 0;
        var pct = (tier.rewardDiscountPercent === undefined || tier.rewardDiscountPercent === null) ? 100 : tier.rewardDiscountPercent;
        var text = (pct >= 100)
          ? fmt(free) + ' ' + mUnit(free) + ' FREE'
          : fmt(free) + ' ' + mUnit(free) + ' at ' + pct + '% off';
        return '<span class="bxgy-promo__highlight">' + text + '</span>';
      }
      /*
       * Matches bxgy-progress-card.liquid's (cart page) current logic exactly —
       * this section's own UI/wording is unchanged, only the calculation feeding it.
       * 1. Walk tiers ascending (rigorous dual-aware keep-best walk) to find bestIndex.
       * 2. Target is simply the next configured tier after bestIndex; need = that
       *    tier's own raw buyMeters minus (totalBuy minus what's already realized),
       *    chained forward past any tier this same formula already treats as met.
       */
      function compute(lines) {
        var totalBuy = 0;
        var buyIdx = {};
        lines.forEach(function (l, i) {
          if (isBuyEligible(l)) { totalBuy += getEffectiveMeters(l); buyIdx[i] = true; }
        });

        var bestFreed = null, bestIndex = -1;
        for (var t = 0; t < tiers.length; t++) {
          var tier = tiers[t];
          var buyMeters = tier.buyMeters || 0;
          if (totalBuy < buyMeters - 1e-9) break;

          var cats = tier.rewardCategories || [];
          var free = tier.freeMeters || 0;
          if (free <= 0 || !cats.length) break;

          var full = allocate(lines, buyIdx, cats, free);
          var paid = totalBuy - full.dualFreed;

          if (paid >= buyMeters - 1e-9) {
            bestFreed = full.freed;
            bestIndex = t;
            continue;
          }

          var dualBudget = totalBuy - buyMeters;
          var capped = allocateBudgetCapped(lines, buyIdx, cats, free, dualBudget);
          if (bestFreed === null || capped.freed > bestFreed + 1e-9) {
            bestFreed = capped.freed;
            bestIndex = t;
          }
          break;
        }

        var realized = bestFreed || 0;
        var next = null, need = 0;
        var idx = bestIndex + 1;
        while (idx < tiers.length) {
          var candidate = tiers[idx];
          var needCandidate = (candidate.buyMeters || 0) - (totalBuy - realized);
          if (needCandidate > 1e-9) {
            next = candidate;
            need = needCandidate;
            break;
          }
          idx++;
        }
        return { next: next, need: need, rawBuy: totalBuy, bestIndex: bestIndex };
      }

      // Deliberately never shows an "earned"/"unlocked" state — always frames forward
      // to the next un-reached tier. Only when every tier is cleared does it fall back
      // to a flat statement of the top tier's benefit (still no "you earned" wording).
      function render(lines) {
        var state = compute(lines);
        var next = state.next;
        if (next) {
          var need = Math.max(0, state.need || 0);
          headlineEl.innerHTML = 'Add ' + fmt(need) + ' more ' + mUnit(need) + ' to get ' + benefitHtml(next);
        } else {
          var top = tiers[tiers.length - 1];
          headlineEl.innerHTML = 'Get ' + benefitHtml(top) + ' on qualifying orders';
        }
      }

      function refreshFromServer() {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { render(cart.items || []); })
          .catch(function () {});
      }

      render(initialLines);
      document.addEventListener('cart:updated', refreshFromServer);
      document.addEventListener('cart:added', refreshFromServer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complementary-picks"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.comp-picks').forEach(function(section) {
      var track = section.querySelector('.comp-picks__track');
      var prev = section.querySelector('.comp-picks__arrow--prev');
      var next = section.querySelector('.comp-picks__arrow--next');
      if (!track || !prev || !next) return;

      function updateArrows() {
        prev.disabled = track.scrollLeft < 10;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
      }

      var card = track.querySelector('.product-card');
      var step = card ? card.offsetWidth + 16 : 300;

      prev.addEventListener('click', function() { track.scrollBy({ left: -step * 2, behavior: 'smooth' }); });
      next.addEventListener('click', function() { track.scrollBy({ left: step * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-orders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function addToCart(variantId, qty) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(parseCartAdd);
    }

    // Shopify rejects with a 422 + JSON {description} (out of stock, quantity
    // limit) — without the ok check that error body counted as success.
    function parseCartAdd(r) {
      return r.json().then(function(data) {
        if (!r.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Could not add to cart.');
          err.cartError = true;
          throw err;
        }
        return data;
      });
    }

    function updateCartBadge() {
      if (window.__cartAdded) { window.__cartAdded(); return; }
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var badge = document.querySelector('[data-cart-count]');
        if (badge) badge.textContent = cart.item_count;
      });
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-reorder]');
      if (btn) {
        var vid = parseInt(btn.dataset.variantId, 10);
        var qty = parseInt(btn.dataset.qty, 10) || 1;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        addToCart(vid, qty).then(function() {
          btn.classList.add('is-added');
          btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> Added';
          updateCartBadge();
          setTimeout(function() {
            btn.classList.remove('is-added');
            btn.disabled = false;
            btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 105.64-11.36L3 10"/></svg> Buy Again';
          }, 2000);
        }).catch(function(err) {
          btn.disabled = false;
          btn.textContent = 'Not available';
          if (err && err.message) btn.title = err.message;
        });
        return;
      }

      var allBtn = e.target.closest('[data-reorder-all]');
      if (allBtn) {
        var items;
        try { items = JSON.parse(allBtn.dataset.items); } catch(ex) { return; }
        items = items.filter(function(i) { return i && i.id; });
        if (!items.length) return;
        allBtn.disabled = true;
        allBtn.textContent = 'Adding...';
        var body = { items: items.map(function(i) { return { id: i.id, quantity: i.qty || 1 }; }) };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(parseCartAdd).then(function() {
          allBtn.classList.add('is-added');
          allBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> Added to Cart';
          updateCartBadge();
          setTimeout(function() {
            allBtn.classList.remove('is-added');
            allBtn.disabled = false;
            allBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 105.64-11.36L3 10"/></svg> Reorder All Available Items';
          }, 2000);
        }).catch(function(err) {
          allBtn.disabled = false;
          allBtn.textContent = 'Some items unavailable';
          if (err && err.message) allBtn.title = err.message;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  var navLinks = document.querySelectorAll('.faq-page__nav-link');
  navLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  var allDetails = document.querySelectorAll('.faq-page__item');
  allDetails.forEach(function(detail) {
    detail.addEventListener('toggle', function() {
      if (this.open) {
        allDetails.forEach(function(other) {
          if (other !== detail && other.open) {
            other.removeAttribute('open');
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-header]');
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    var overlay = document.querySelector('[data-drawer-overlay]');
    var closeBtn = document.querySelector('[data-drawer-close]');
    var lastScroll = 0;

    if (!header) return;

    // Sticky hide/show
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;margin-top:-1px;pointer-events:none;';
    header.before(sentinel);
    new IntersectionObserver(function(entries) {
      header.classList.toggle('is-sticky', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(sentinel);

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var current = window.scrollY;
          if (current > lastScroll && current > 100) {
            header.classList.add('is-hidden');
          } else {
            header.classList.remove('is-hidden');
          }
          lastScroll = current;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Mobile drawer
    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (toggle) toggle.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Mega menu triggers
    var megaParents = document.querySelectorAll('[data-mega-parent]');
    var closeTimer = null;

    function openMega(parent) {
      clearTimeout(closeTimer);
      megaParents.forEach(function(p) { p.classList.remove('is-open'); });
      parent.classList.add('is-open');
      parent.querySelector('[data-mega-trigger]').setAttribute('aria-expanded', 'true');
    }
    function closeMega(parent) {
      parent.classList.remove('is-open');
      parent.querySelector('[data-mega-trigger]').setAttribute('aria-expanded', 'false');
    }
    function closeAllMegas() {
      megaParents.forEach(function(p) { closeMega(p); });
    }

    megaParents.forEach(function(parent) {
      var trigger = parent.querySelector('[data-mega-trigger]');

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (parent.classList.contains('is-open')) {
          closeMega(parent);
        } else {
          openMega(parent);
        }
      });

      parent.addEventListener('mouseenter', function() {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          openMega(parent);
        }
      });

      parent.addEventListener('mouseleave', function() {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          closeTimer = setTimeout(function() { closeMega(parent); }, 150);
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-mega-parent]')) closeAllMegas();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeAllMegas();
    });

    // Auto-split long mega lists into columns
    document.querySelectorAll('.header__mega-list').forEach(function(list) {
      if (list.children.length > 8) {
        list.classList.add('header__mega-list--long');
      }
    });

    // More panel hover (same pattern as mega menus)
    var moreEl = document.querySelector('[data-more-menu]');
    var moreTrigger = document.querySelector('[data-more-trigger]');
    var moreCloseTimer = null;

    function openMore() {
      clearTimeout(moreCloseTimer);
      closeAllMegas();
      moreEl.classList.add('is-open');
      moreTrigger.setAttribute('aria-expanded', 'true');
    }
    function closeMore() {
      moreEl.classList.remove('is-open');
      moreTrigger.setAttribute('aria-expanded', 'false');
    }

    if (moreEl && moreTrigger) {
      moreTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        moreEl.classList.contains('is-open') ? closeMore() : openMore();
      });
      moreEl.addEventListener('mouseenter', function() {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) openMore();
      });
      moreEl.addEventListener('mouseleave', function() {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          moreCloseTimer = setTimeout(closeMore, 150);
        }
      });
    }

    // Close More on outside click / Escape
    document.addEventListener('click', function(e) {
      if (moreEl && !e.target.closest('[data-more-menu]')) closeMore();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && moreEl) closeMore();
    });

    // Predictive search
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchOverlay = document.querySelector('[data-search-overlay]');
    var searchInput = document.querySelector('[data-search-input]');
    var searchResults = document.querySelector('[data-search-results]');
    var searchEmpty = document.querySelector('[data-search-empty]');
    var searchClear = document.querySelector('[data-search-clear]');
    var searchCloseEls = document.querySelectorAll('[data-search-close]');
    var searchTimer = null;
    var searchRoute = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    function openSearch() {
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { searchInput.focus(); }, 100);
    }

    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (searchToggle && searchOverlay) {
      searchToggle.addEventListener('click', function(e) {
        e.preventDefault();
        openSearch();
      });

      searchCloseEls.forEach(function(el) {
        el.addEventListener('click', closeSearch);
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) closeSearch();
      });

      if (searchClear) {
        searchClear.addEventListener('click', function() {
          searchInput.value = '';
          searchClear.hidden = true;
          searchResults.innerHTML = '';
          if (searchEmpty) {
            searchResults.appendChild(searchEmpty);
            searchEmpty.style.display = '';
          }
          searchInput.focus();
        });
      }

      searchInput.addEventListener('input', function() {
        var q = searchInput.value.trim();
        if (searchClear) searchClear.hidden = q.length === 0;
        clearTimeout(searchTimer);
        if (q.length < 2) {
          searchResults.innerHTML = '';
          if (searchEmpty) {
            searchEmpty.style.display = '';
            searchResults.appendChild(searchEmpty);
          }
          return;
        }
        searchTimer = setTimeout(function() { fetchResults(q); }, 250);
      });
    }

    function fetchResults(query) {
      searchResults.innerHTML = '<div class="search-overlay__loading">Searching...</div>';
      var url = searchRoute + 'search?q=' + encodeURIComponent(query) + '&type=product,article,page&section_id=predictive-search';
      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-predictive-content]');
          if (content) {
            searchResults.innerHTML = content.innerHTML;
          } else {
            searchResults.innerHTML = '<div class="search-overlay__no-results"><p>No results for "' + query + '"</p><a href="' + searchRoute + 'collections">Browse collections</a></div>';
          }
        })
        .catch(function() {
          searchResults.innerHTML = '<div class="search-overlay__no-results"><p>Something went wrong. Try again.</p></div>';
        });
    }

    // Account sheet
    var accountSheet = document.querySelector('[data-account-sheet]');
    var accountToggles = document.querySelectorAll('[data-account-toggle]');
    var accountCloseEls = document.querySelectorAll('[data-account-close]');

    function openAccountSheet() {
      if (!accountSheet) return;
      // Close mobile drawer if open
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      accountSheet.classList.add('is-open');
      accountSheet.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // Desktop: position below header
      if (window.matchMedia('(min-width: 990px)').matches) {
        var panel = accountSheet.querySelector('.account-sheet__panel');
        panel.style.top = (header.getBoundingClientRect().bottom) + 'px';
      }
    }

    function closeAccountSheet() {
      if (!accountSheet) return;
      accountSheet.classList.remove('is-open');
      accountSheet.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    accountToggles.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        accountSheet.classList.contains('is-open') ? closeAccountSheet() : openAccountSheet();
      });
    });

    accountCloseEls.forEach(function(el) {
      el.addEventListener('click', closeAccountSheet);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && accountSheet && accountSheet.classList.contains('is-open')) closeAccountSheet();
    });

    // Priority+ nav
    var nav = document.querySelector('[data-priority-nav]');
    var moreMenu = document.querySelector('[data-more-menu]');
    var moreList = document.querySelector('[data-more-list]');
    if (nav && moreMenu && moreList) {
      var items = Array.prototype.slice.call(nav.querySelectorAll('[data-nav-item]'));
      var itemWidths = [];
      var gap = 0;

      function measureItems() {
        nav.classList.remove('is-measured');
        itemWidths = [];
        items.forEach(function(item) { item.hidden = false; item.style.display = ''; });
        moreMenu.hidden = true;
        gap = parseFloat(getComputedStyle(nav).columnGap) || 20;
        items.forEach(function(item) {
          itemWidths.push(item.getBoundingClientRect().width);
        });
      }

      function addOverflowItem(item, columnsWrap) {
        var isMega = item.querySelector('[data-mega-trigger]');
        var title = isMega ? isMega.textContent.trim() : item.textContent.trim();
        var col = document.createElement('div');
        col.className = 'header__more-col';

        if (item.tagName === 'A') {
          var heading = document.createElement('a');
          heading.className = 'header__more-heading';
          heading.href = item.href;
          heading.textContent = title;
          col.appendChild(heading);
          columnsWrap.appendChild(col);
          return;
        }

        var headingEl = document.createElement('span');
        headingEl.className = 'header__more-heading';
        headingEl.textContent = title;
        col.appendChild(headingEl);

        var firstCol = item.querySelector('.header__mega-col:first-child');
        var childLinks = firstCol ? firstCol.querySelectorAll('.header__mega-link') : [];
        childLinks.forEach(function(cl) {
          var sub = document.createElement('a');
          sub.className = 'header__more-link';
          sub.href = cl.href;
          sub.textContent = cl.textContent.trim();
          col.appendChild(sub);
        });

        columnsWrap.appendChild(col);
      }

      function updateNav() {
        var navWidth = nav.getBoundingClientRect().width;
        var moreWidth = 70 + gap;
        var usedWidth = 0;
        var overflowed = false;
        moreList.innerHTML = '';

        var columnsWrap = document.createElement('div');
        columnsWrap.className = 'header__more-columns';

        for (var i = 0; i < items.length; i++) {
          var needed = itemWidths[i] + (i > 0 ? gap : 0);
          if (!overflowed && (usedWidth + needed + moreWidth > navWidth) && i < items.length - 1) {
            overflowed = true;
          }
          if (!overflowed && (usedWidth + needed <= navWidth)) {
            items[i].hidden = false;
            items[i].style.display = '';
            usedWidth += needed;
          } else {
            overflowed = true;
            items[i].hidden = true;
            items[i].style.display = 'none';
            addOverflowItem(items[i], columnsWrap);
          }
        }

        if (overflowed) moreList.appendChild(columnsWrap);
        moreMenu.hidden = !overflowed;
        nav.classList.add('is-measured');
      }

      measureItems();
      updateNav();

      var resizeTicking = false;
      window.addEventListener('resize', function() {
        if (!resizeTicking) {
          requestAnimationFrame(function() {
            measureItems();
            updateNav();
            resizeTicking = false;
          });
          resizeTicking = true;
        }
      }, { passive: true });
    }
  })();

  (function() {
    var cartToggle = document.querySelector('[data-cart-drawer-toggle]');
    if (cartToggle) {
      cartToggle.addEventListener('click', function(e) {
        e.preventDefault();
        if (window.__cartDrawerOpen) { window.__cartDrawerOpen(); return; }
        window.location.href = cartToggle.dataset.cartUrl || '/cart';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-lookbook"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var roots = document.querySelectorAll('[data-hlb-root]');
    roots.forEach(function(root) {
      var TOUCH_THRESHOLD = 40;

      function goToSlide(slider, index) {
        var slidesWrap = slider.querySelector('[data-hlb-slides]');
        if (!slidesWrap) return;
        var slides = Array.from(slidesWrap.children);
        if (!slides.length) return;
        var max = slides.length - 1;
        var next = Math.max(0, Math.min(max, Number(index) || 0));
        slider.dataset.currentIndex = String(next);
        slidesWrap.style.transform = 'translate3d(-' + (next * 100) + '%, 0, 0)';
        slider.querySelectorAll('[data-slide-to]').forEach(function(dot, idx) {
          dot.classList.toggle('is-active', idx === next);
        });
      }

      function initSlider(slider) {
        var slidesWrap = slider.querySelector('[data-hlb-slides]');
        if (!slidesWrap || slidesWrap.children.length <= 1) return;
        slider.dataset.currentIndex = '0';

        slider.querySelectorAll('[data-slide-to]').forEach(function(dot) {
          dot.addEventListener('click', function(e) {
            e.preventDefault();
            goToSlide(slider, dot.dataset.slideTo);
          });
        });

        var touchStartX = 0;
        slidesWrap.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
        slidesWrap.addEventListener('touchend', function(e) {
          var diff = touchStartX - e.changedTouches[0].clientX;
          if (Math.abs(diff) < TOUCH_THRESHOLD) return;
          var current = Number(slider.dataset.currentIndex || 0);
          var maxSlide = slidesWrap.children.length - 1;
          goToSlide(slider, diff > 0 ? Math.min(current + 1, maxSlide) : Math.max(current - 1, 0));
        }, { passive: true });
      }

      root.querySelectorAll('[data-hlb-slider]').forEach(initSlider);

      var track = root.querySelector('[data-hlb-track]');
      var prevBtn = root.querySelector('[data-hlb-prev]');
      var nextBtn = root.querySelector('[data-hlb-next]');

      if (track && prevBtn && nextBtn) {
        var scrollAmount = function() {
          var card = track.querySelector('.hlb__card');
          if (!card) return 300;
          return card.offsetWidth + (parseInt(getComputedStyle(track).gap) || 12);
        };

        function updateArrows() {
          var atStart = track.scrollLeft <= 2;
          var atEnd = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
          prevBtn.classList.toggle('is-hidden', atStart);
          nextBtn.classList.toggle('is-hidden', atEnd);
        }

        updateArrows();
        track.addEventListener('scroll', updateArrows, { passive: true });

        prevBtn.addEventListener('click', function() {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', function() {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      function openQuickView(btn) {
        if (!btn) return;
        var url = btn.getAttribute('data-product-url');
        if (!url) return;
        var handle = url.split('/products/')[1].split('?')[0];
        var cardImg = btn.closest('.hlb__card') && btn.closest('.hlb__card').querySelector('.hlb__slide.is-active img, .hlb__slide:first-child img');
        var imgSrc = cardImg ? cardImg.src : '';
        var extraData = {
          meta: btn.getAttribute('data-card-meta') || '',
          reviewAvg: parseInt(btn.getAttribute('data-review-avg')) || 0,
          reviewCount: parseInt(btn.getAttribute('data-review-count')) || 0,
          rateUnit: btn.getAttribute('data-rate-unit') || ''
        };
        if (window.__qvOpen) {
          window.__qvOpen(handle, imgSrc, extraData);
        } else {
          window.location.href = url;
        }
      }

      root.addEventListener('click', function(e) {
        var qvBtn = e.target.closest('.product-card__quick-view');
        if (qvBtn) {
          e.preventDefault();
          e.stopPropagation();
          openQuickView(qvBtn);
          return;
        }
        var link = e.target.closest('.hlb__img-link');
        if (!link) return;
        e.preventDefault();
        e.stopPropagation();
        var card = link.closest('.hlb__card');
        if (!card) return;
        var btn = card.querySelector('.product-card__quick-view');
        openQuickView(btn);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-masonry-root]');
    if (!section) return;

    var sectionId = section.dataset.sectionId;
    var sectionEl = document.querySelector('.section-' + sectionId);
    var root = section;
    var source = root.querySelector('[data-masonry-source]');
    var columnsWrap = root.querySelector('[data-masonry-columns]');
    var infinite = document.getElementById('lookbook-infinite-' + sectionId);
    if (!source || !columnsWrap) return;

    var loading = false;
    var finished = !infinite;
    var TOUCH_THRESHOLD = 40;

    function goToSlide(slider, index) {
      var slidesWrap = slider.querySelector('[data-lookbook-slides]');
      if (!slidesWrap) return;
      var slides = Array.from(slidesWrap.children);
      if (!slides.length) return;
      var max = slides.length - 1;
      var next = Math.max(0, Math.min(max, Number(index) || 0));
      slider.dataset.currentIndex = String(next);
      slidesWrap.style.transform = 'translate3d(-' + (next * 100) + '%, 0, 0)';
      slider.querySelectorAll('[data-slide-to]').forEach(function(dot, idx) {
        var active = idx === next;
        dot.classList.toggle('is-active', active);
      });
    }

    /* ── Style filter ── */
    var styleBarEl = document.querySelector('[data-lb-style-filter]');
    var styleTrackEl = styleBarEl ? styleBarEl.querySelector('[data-lb-style-track]') : null;
    var activeStyle = 'all';

    function refreshStyleFilter() {
      if (!styleBarEl || !styleTrackEl) return;
      var registry = new Map();
      document.querySelectorAll('.lookbook__card').forEach(function(card) {
        var seen = new Set();
        card.querySelectorAll('[data-slide-style]').forEach(function(slide) {
          var handle = slide.dataset.slideStyle;
          if (!handle || seen.has(handle)) return;
          seen.add(handle);
          var label = slide.dataset.slideStyleLabel || handle;
          var entry = registry.get(handle);
          if (entry) { entry.count += 1; } else { registry.set(handle, { label: label, count: 1 }); }
        });
      });

      if (registry.size === 0) {
        styleBarEl.hidden = true;
        return;
      }
      styleBarEl.hidden = false;

      var allPill = styleTrackEl.querySelector('[data-style="all"]');
      styleTrackEl.innerHTML = '';
      if (!allPill) {
        allPill = document.createElement('button');
        allPill.type = 'button';
        allPill.className = 'lb-style-pill';
        allPill.setAttribute('data-lb-style-pill', '');
        allPill.setAttribute('data-style', 'all');
        allPill.textContent = 'All';
      }
      allPill.classList.toggle('is-active', activeStyle === 'all');
      styleTrackEl.appendChild(allPill);

      Array.from(registry.entries())
        .sort(function(a, b) { return b[1].count - a[1].count; })
        .forEach(function(entry) {
          var handle = entry[0];
          var data = entry[1];
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'lb-style-pill' + (activeStyle === handle ? ' is-active' : '');
          btn.setAttribute('data-lb-style-pill', '');
          btn.setAttribute('data-style', handle);
          btn.textContent = data.label;
          styleTrackEl.appendChild(btn);
        });

      if (activeStyle !== 'all' && !registry.has(activeStyle)) {
        applyStyleFilter('all');
      }
    }

    function applyStyleFilter(handle) {
      activeStyle = handle;
      if (styleTrackEl) {
        styleTrackEl.querySelectorAll('[data-lb-style-pill]').forEach(function(btn) {
          btn.classList.toggle('is-active', btn.dataset.style === handle);
        });
      }

      document.querySelectorAll('.lookbook__card').forEach(function(card) {
        var slider = card.querySelector('[data-lookbook-slider]');
        if (handle === 'all') {
          card.classList.remove('is-style-hidden');
          if (slider) goToSlide(slider, 0);
          return;
        }
        var matchSlide = card.querySelector('[data-slide-style="' + handle + '"]');
        if (matchSlide) {
          card.classList.remove('is-style-hidden');
          if (slider) {
            var slidesWrap = slider.querySelector('[data-lookbook-slides]');
            var idx = slidesWrap ? Array.from(slidesWrap.children).indexOf(matchSlide) : -1;
            if (idx > -1) goToSlide(slider, idx);
          }
        } else {
          card.classList.add('is-style-hidden');
        }
      });
    }

    if (styleTrackEl) {
      styleTrackEl.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-lb-style-pill]');
        if (!btn) return;
        autoChainCount = 0;
        applyStyleFilter(btn.dataset.style);
        if (btn.dataset.style !== 'all') {
          var visibleNow = document.querySelectorAll('.lookbook__card:not(.is-style-hidden)').length;
          if (visibleNow < AUTO_CHAIN_MIN_VISIBLE) {
            autoChainCount += 1;
            loadNext();
          }
        }
      });
    }

    function initSlider(slider) {
      if (!slider || slider.dataset.sliderReady === 'true') return;
      var slidesWrap = slider.querySelector('[data-lookbook-slides]');
      if (!slidesWrap || !slidesWrap.children.length) return;
      slider.dataset.sliderReady = 'true';
      slider.dataset.currentIndex = '0';
      slidesWrap.style.transform = 'translate3d(0,0,0)';

      slider.querySelectorAll('[data-slide-to]').forEach(function(dot) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(slider, Number(dot.dataset.slideTo || 0));
        });
      });

      var touchStartX = 0, touchEndX = 0;
      slider.addEventListener('touchstart', function(e) {
        if (!e.touches || !e.touches.length) return;
        touchStartX = e.touches[0].clientX;
        touchEndX = touchStartX;
      }, { passive: true });
      slider.addEventListener('touchmove', function(e) {
        if (!e.touches || !e.touches.length) return;
        touchEndX = e.touches[0].clientX;
      }, { passive: true });
      slider.addEventListener('touchend', function() {
        var delta = touchEndX - touchStartX;
        var current = Number(slider.dataset.currentIndex || 0);
        var total = slidesWrap.children.length;
        if (Math.abs(delta) >= TOUCH_THRESHOLD && total > 1) {
          if (delta < 0) goToSlide(slider, (current + 1) % total);
          else goToSlide(slider, (current - 1 + total) % total);
        }
      });
    }

    function initSlidersIn(container) {
      if (!container) return;
      container.querySelectorAll('[data-lookbook-slider]').forEach(initSlider);
    }

    document.addEventListener('click', function(e) {
      var arrow = e.target.closest('[data-lb-arrow]');
      if (!arrow) return;
      e.preventDefault();
      e.stopPropagation();
      var slider = arrow.closest('[data-lookbook-slider]');
      if (!slider) return;
      var slidesWrap = slider.querySelector('[data-lookbook-slides]');
      if (!slidesWrap) return;
      var total = slidesWrap.children.length;
      if (total <= 1) return;
      var current = Number(slider.dataset.currentIndex || 0);
      if (arrow.dataset.lbArrow === 'prev') {
        goToSlide(slider, (current - 1 + total) % total);
      } else {
        goToSlide(slider, (current + 1) % total);
      }
    });

    var mobileCols = 1;

    function getColCount() {
      var w = window.innerWidth;
      var desktop = parseInt(getComputedStyle(root).getPropertyValue('--lb-desktop-columns'), 10) || 4;
      var tablet = parseInt(getComputedStyle(root).getPropertyValue('--lb-tablet-columns'), 10) || 3;
      if (w >= 1200) return desktop;
      if (w >= 750) return tablet;
      return mobileCols;
    }

    function ensureColumns(count) {
      var existing = Array.from(columnsWrap.children);
      if (existing.length === count) return existing;
      columnsWrap.innerHTML = '';
      var cols = [];
      for (var i = 0; i < count; i++) {
        var col = document.createElement('div');
        col.className = 'lookbook__col';
        col.setAttribute('data-col-index', String(i));
        columnsWrap.appendChild(col);
        cols.push(col);
      }
      return cols;
    }

    function shortestColumn(cols) {
      var minCol = cols[0], minH = cols[0].offsetHeight;
      for (var i = 1; i < cols.length; i++) {
        var h = cols[i].offsetHeight;
        if (h < minH) { minH = h; minCol = cols[i]; }
      }
      return minCol;
    }

    function placeCards(cards) {
      var cols = ensureColumns(getColCount());
      cards.forEach(function(card) { shortestColumn(cols).appendChild(card); });
      initSlidersIn(columnsWrap);
    }

    function repackAll() {
      var cards = Array.from(source.children).concat(Array.from(columnsWrap.querySelectorAll('.lookbook__card')));
      source.innerHTML = '';
      columnsWrap.innerHTML = '';
      placeCards(cards);
    }

    function setStatus(text) {
      if (!infinite) return;
      var el = infinite.querySelector('[data-status]');
      if (el) el.textContent = text || '';
    }

    var autoChainCount = 0;
    var AUTO_CHAIN_MIN_VISIBLE = 4;
    var AUTO_CHAIN_MAX = 8;

    function loadNext() {
      if (!infinite || loading || finished) return;
      var nextLink = infinite.querySelector('[data-next-url]');
      var href = nextLink ? nextLink.getAttribute('href') : '';
      if (!href) { finished = true; return; }
      loading = true;
      setStatus('Loading...');

      var url = new URL(href, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      var shouldChain = false;

      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function(res) {
          if (!res.ok) throw new Error('Failed');
          return res.text();
        })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newRoot = doc.getElementById('lookbook-masonry-' + sectionId);
          if (!newRoot) throw new Error('Root not found');
          var newSource = newRoot.querySelector('[data-masonry-source]');
          if (!newSource) throw new Error('Source not found');
          placeCards(Array.from(newSource.children));
          refreshStyleFilter();
          if (activeStyle !== 'all') applyStyleFilter(activeStyle);

          var newInfinite = doc.getElementById('lookbook-infinite-' + sectionId);
          var newNext = newInfinite ? newInfinite.querySelector('[data-next-url]') : null;
          if (newNext && newNext.getAttribute('href')) {
            nextLink.setAttribute('href', newNext.getAttribute('href'));
          } else {
            finished = true;
            infinite.remove();
          }

          /* A style filter hides most cards, so a normal scroll-triggered
             fetch alone can leave almost nothing visible — chain straight
             into another fetch (no scroll needed) until there's enough to
             see, pagination runs out, or the safety cap stops it. */
          if (activeStyle !== 'all' && !finished && autoChainCount < AUTO_CHAIN_MAX) {
            var visibleCount = document.querySelectorAll('.lookbook__card:not(.is-style-hidden)').length;
            if (visibleCount < AUTO_CHAIN_MIN_VISIBLE) {
              shouldChain = true;
              autoChainCount += 1;
            }
          }
          if (!shouldChain) setStatus('');
        })
        .catch(function() { setStatus('Failed to load more'); })
        .finally(function() {
          loading = false;
          if (shouldChain) loadNext();
        });
    }

    function isDesktop() { return window.innerWidth >= 1200; }
    function isTablet() { return window.innerWidth >= 750 && window.innerWidth < 1200; }

    function applyCols(count, persist) {
      var value = parseInt(count, 10);
      if (![2, 3, 4].includes(value)) return;
      if (isDesktop()) {
        root.style.setProperty('--lb-desktop-columns', String(value));
        if (persist) try { localStorage.setItem('lbDesktopCols:' + sectionId, String(value)); } catch(e) {}
      } else if (isTablet()) {
        root.style.setProperty('--lb-tablet-columns', String(value));
        if (persist) try { localStorage.setItem('lbTabletCols:' + sectionId, String(value)); } catch(e) {}
      }
      document.querySelectorAll('[data-col-control]').forEach(function(btn) {
        btn.classList.toggle('is-active', Number(btn.dataset.cols) === value);
      });
      repackAll();
    }

    placeCards(Array.from(source.children));
    refreshStyleFilter();

    try {
      var key = isDesktop() ? 'lbDesktopCols:' + sectionId : 'lbTabletCols:' + sectionId;
      var saved = localStorage.getItem(key);
      if (saved) applyCols(saved, false);
    } catch(e) {}

    document.querySelectorAll('[data-col-control]').forEach(function(btn) {
      btn.addEventListener('click', function() { applyCols(btn.dataset.cols, true); });
    });


    var reelsScroller = null;
    var reelsLastY = 0;
    var reelsHeader = null;

    function onReelsScroll() {
      if (!reelsScroller) return;
      var y = reelsScroller.scrollTop;
      if (!reelsHeader) reelsHeader = document.querySelector('[data-header]');
      if (y > reelsLastY && y > 60) {
        if (reelsHeader) reelsHeader.classList.add('is-hidden');
      } else if (y < reelsLastY) {
        if (reelsHeader) reelsHeader.classList.remove('is-hidden');
      }
      reelsLastY = y;
      if (!finished && !loading && reelsScroller.scrollHeight - y - reelsScroller.clientHeight < 800) {
        loadNext();
      }
    }

    function hideChatWidget(hide) {
      var selectors = ['#tidio-chat', '#gorgias-chat-container', '.intercom-lightweight-app', '.drift-frame-chat', '#crisp-chatbox', '#chat-widget-container', 'iframe[title*="chat" i]', 'iframe[title*="Chat" i]', '[class*="chat-widget"]', '[id*="chat-widget"]'];
      selectors.forEach(function(sel) {
        var el = document.querySelector(sel);
        if (el) el.style.display = hide ? 'none' : '';
      });
    }

    function updateReelsMode() {
      if (window.innerWidth < 750 && mobileCols === 1) {
        sectionEl.classList.add('is-reels');
        var annBar = document.querySelector('.announcement-bar');
        if (annBar) annBar.closest('.shopify-section').style.display = 'none';
        hideChatWidget(true);
        requestAnimationFrame(function() {
          reelsScroller = root.querySelector('[data-masonry-columns]');
          if (reelsScroller) {
            reelsScroller.removeEventListener('scroll', onReelsScroll);
            reelsScroller.addEventListener('scroll', onReelsScroll, { passive: true });
          }
        });
      } else {
        sectionEl.classList.remove('is-reels');
        var annBar = document.querySelector('.announcement-bar');
        if (annBar) annBar.closest('.shopify-section').style.display = '';
        hideChatWidget(false);
        if (reelsScroller) {
          reelsScroller.removeEventListener('scroll', onReelsScroll);
          reelsScroller = null;
        }
        if (reelsHeader) reelsHeader.classList.remove('is-hidden');
      }
    }

    document.querySelectorAll('[data-lb-mcol]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var val = parseInt(btn.dataset.lbMcol, 10);
        if (![1, 2].includes(val)) return;
        mobileCols = val;
        root.style.setProperty('--lb-cols', String(val));
        document.querySelectorAll('[data-lb-mcol]').forEach(function(b) {
          b.classList.toggle('is-active', Number(b.dataset.lbMcol) === val);
        });
        try { localStorage.setItem('lbMobileCols:' + sectionId, String(val)); } catch(e) {}
        updateReelsMode();
        repackAll();
      });
    });

    updateReelsMode();

    var resizeTimer = null;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() { updateReelsMode(); repackAll(); }, 160);
    });

    if (infinite) {
      var sentinel = infinite.querySelector('[data-sentinel]');
      if (sentinel) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) { if (entry.isIntersecting) loadNext(); });
        }, { rootMargin: '500px 0px' });
        io.observe(sentinel);
      }
    }

    /* Quick View — uses global window.__qvOpen from quick-view-modal snippet */
    function openCardQv(card) {
      if (!card || !card.dataset.lbHandle) return;
      var cardImg = card.querySelector('.lookbook__img');
      var imgSrc = cardImg ? cardImg.src : '';
      window.__qvOpen(card.dataset.lbHandle, imgSrc, {
        meta: card.dataset.lbMeta || '',
        reviewAvg: parseInt(card.dataset.lbReviewAvg) || 0,
        reviewCount: parseInt(card.dataset.lbReviewCount) || 0,
        rateUnit: card.dataset.lbUnit || ''
      });
    }

    /* Click on image opens quick-view (all devices) */
    document.addEventListener('click', function(e) {
      var link = e.target.closest('.lookbook__img-link');
      if (!link) return;
      var card = link.closest('.lookbook__card');
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      openCardQv(card);
    });

    /* ── Filter / Sort JS ── */
    var drawerEl = document.querySelector('[data-lb-drawer]');
    var overlayEl = document.querySelector('[data-lb-overlay]');

    function openDrawer() {
      if (!drawerEl || !overlayEl) return;
      drawerEl.classList.add('is-open');
      overlayEl.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawerEl || !overlayEl) return;
      drawerEl.classList.remove('is-open');
      overlayEl.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-lb-filter-toggle]').forEach(function(btn) {
      btn.addEventListener('click', openDrawer);
    });
    if (overlayEl) overlayEl.addEventListener('click', closeDrawer);
    document.querySelectorAll('[data-lb-filter-close]').forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });

    document.querySelectorAll('[data-lb-dropdown-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        var panel = trigger.parentElement.querySelector('[data-lb-dropdown-panel]');
        if (!panel) return;
        var isOpen = panel.classList.contains('is-open');
        document.querySelectorAll('[data-lb-dropdown-panel].is-open').forEach(function(p) {
          p.classList.remove('is-open');
          p.previousElementSibling && p.previousElementSibling.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          panel.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function() {
      document.querySelectorAll('[data-lb-dropdown-panel].is-open').forEach(function(p) {
        p.classList.remove('is-open');
      });
      document.querySelectorAll('[data-lb-dropdown-trigger]').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
      });
    });

    document.querySelectorAll('[data-lb-dropdown-panel]').forEach(function(panel) {
      panel.addEventListener('click', function(e) { e.stopPropagation(); });
    });

    var sortSelect = document.querySelector('[data-lb-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    function submitFilterForm(form) {
      var formData = new FormData(form);
      var url = new URL(window.location.pathname, window.location.origin);
      var sortBy = new URL(window.location.href).searchParams.get('sort_by');
      if (sortBy) url.searchParams.set('sort_by', sortBy);
      for (var pair of formData.entries()) {
        if (pair[1] !== '' && pair[1] !== '0') {
          url.searchParams.append(pair[0], pair[1]);
        }
      }
      window.location.href = url.toString();
    }

    document.querySelectorAll('[data-lb-filter-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        submitFilterForm(form);
      });
    });

    document.querySelectorAll('[data-lb-dropdown-apply]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var form = btn.closest('form');
        if (form) submitFilterForm(form);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (function() {
    var btns = document.querySelectorAll('[data-copy-link]');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        navigator.clipboard.writeText(window.location.href).then(function() {
          btn.setAttribute('aria-label', 'Copied!');
          setTimeout(function() {
            btn.setAttribute('aria-label', 'Copy link');
          }, 2000);
        });
      });
    });

    var content = document.querySelector('[data-article-content]');
    if (!content) return;

    var tocList = document.querySelector('[data-toc-list]');
    var tocNav = document.querySelector('[data-article-toc]');
    var tocToggle = document.querySelector('[data-toc-toggle]');

    var headings = content.querySelectorAll('h2');
    if (headings.length > 1 && tocList) {
      headings.forEach(function(h, i) {
        var id = 'section-' + i;
        h.setAttribute('id', id);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent;
        li.appendChild(a);
        tocList.appendChild(li);
      });
      tocNav.classList.add('is-open');
    } else if (tocNav) {
      tocNav.style.display = 'none';
    }

    if (tocToggle) {
      tocToggle.addEventListener('click', function() {
        tocNav.classList.toggle('is-open');
      });
    }

    var faqHeading = null;
    headings.forEach(function(h) {
      if (h.textContent.trim().toLowerCase().indexOf('frequently asked') !== -1 ||
          h.textContent.trim().toLowerCase() === 'faq' ||
          h.textContent.trim().toLowerCase() === 'faqs') {
        faqHeading = h;
      }
    });

    if (faqHeading) {
      var faqItems = [];
      var el = faqHeading.nextElementSibling;
      while (el && el.tagName !== 'H2') {
        if (el.tagName === 'H3') {
          var question = el.textContent.trim();
          var answerParts = [];
          var nextEl = el.nextElementSibling;
          while (nextEl && nextEl.tagName !== 'H3' && nextEl.tagName !== 'H2') {
            answerParts.push(nextEl);
            nextEl = nextEl.nextElementSibling;
          }
          faqItems.push({ question: question, qEl: el, answerEls: answerParts });
          el = nextEl;
        } else {
          el = el.nextElementSibling;
        }
      }

      if (faqItems.length > 0) {
        var faqContainer = document.createElement('div');
        faqContainer.className = 'article__faq-wrap';

        faqItems.forEach(function(item) {
          var faqItem = document.createElement('div');
          faqItem.className = 'article__faq-item';

          var btn = document.createElement('button');
          btn.className = 'article__faq-q';
          btn.setAttribute('type', 'button');
          btn.textContent = item.question;

          var ansDiv = document.createElement('div');
          ansDiv.className = 'article__faq-a';
          item.answerEls.forEach(function(p) {
            ansDiv.appendChild(p);
          });

          btn.addEventListener('click', function() {
            faqItem.classList.toggle('is-open');
          });

          faqItem.appendChild(btn);
          faqItem.appendChild(ansDiv);
          faqContainer.appendChild(faqItem);

          item.qEl.remove();
        });

        faqHeading.parentNode.insertBefore(faqContainer, faqHeading.nextSibling);

        var faqSchema = {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          'mainEntity': faqItems.map(function(item) {
            return {
              '@type': 'Question',
              'name': item.question,
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': item.answerEls.map(function(el) { return el.textContent; }).join(' ').trim()
              }
            };
          })
        };

        var script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(faqSchema);
        document.head.appendChild(script);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    /* ── Mobile drawer ── */
    var mobileToggle = document.getElementById('filter-toggle-mobile');
    var drawer = document.getElementById('filter-drawer');
    var overlay = document.getElementById('filter-overlay');
    var closeBtn = document.getElementById('filter-close');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (mobileToggle) mobileToggle.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    /* ── Desktop dropdown filters ── */
    var dropdowns = document.querySelectorAll('[data-filter-dropdown]');
    dropdowns.forEach(function(dd) {
      var trigger = dd.querySelector('[data-dropdown-trigger]');
      var panel = dd.querySelector('[data-dropdown-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = panel.classList.contains('is-open');

        document.querySelectorAll('.cf-dropdown__panel.is-open').forEach(function(p) {
          p.classList.remove('is-open');
          p.closest('[data-filter-dropdown]').querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          panel.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-filter-dropdown]')) {
        document.querySelectorAll('.cf-dropdown__panel.is-open').forEach(function(p) {
          p.classList.remove('is-open');
          p.closest('[data-filter-dropdown]').querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'false');
        });
      }
    });

    /* ── Sort ── */
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    /* ── Filter form submit (both mobile and desktop) ── */
    document.querySelectorAll('[data-filter-form]').forEach(function(filterForm) {
      filterForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(filterForm);
        var url = new URL(window.location.pathname, window.location.origin);
        var sortBy = new URL(window.location.href).searchParams.get('sort_by');
        if (sortBy) url.searchParams.set('sort_by', sortBy);
        for (var pair of formData.entries()) {
          if (pair[1] !== '' && pair[1] !== '0') {
            url.searchParams.append(pair[0], pair[1]);
          }
        }
        window.location.href = url.toString();
      });
    });

    /* ── Sibling cards scroll ── */
    var sibWrap = document.querySelector('[data-sib-scroll-row]');
    if (sibWrap) {
      var sibRow = sibWrap.querySelector('.collection-siblings__cards');
      if (sibRow) {
        function sibUpdate() {
          var sl = sibRow.scrollLeft;
          var sw = sibRow.scrollWidth;
          var cw = sibRow.clientWidth;
          sibWrap.classList.toggle('can-scroll-left', sl > 4);
          sibWrap.classList.toggle('can-scroll-right', sl + cw < sw - 4);
        }
        sibRow.addEventListener('scroll', sibUpdate, { passive: true });
        sibUpdate();
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(sibUpdate).observe(sibRow);
        }
        var sibLeft = sibWrap.querySelector('[data-sib-scroll-left]');
        var sibRight = sibWrap.querySelector('[data-sib-scroll-right]');
        if (sibLeft) sibLeft.addEventListener('click', function() {
          sibRow.scrollBy({ left: -(sibRow.clientWidth * 0.7), behavior: 'smooth' });
        });
        if (sibRight) sibRight.addEventListener('click', function() {
          sibRow.scrollBy({ left: sibRow.clientWidth * 0.7, behavior: 'smooth' });
        });
      }
    }

    /* ── Grid toggle ── */
    var gridToggle = document.querySelector('[data-grid-toggle]');
    var collectionGrid = document.querySelector('.collection-grid');
    if (gridToggle && collectionGrid) {
      function getBreakpoint() {
        var w = window.innerWidth;
        if (w >= 990) return 'desktop';
        if (w >= 750) return 'tablet';
        return 'mobile';
      }

      var gridDefaults = { mobile: '2', tablet: '3', desktop: '4' };

      function getStorageKey() {
        return 'fvs_grid_cols_' + getBreakpoint();
      }

      function getDefaultCols() {
        var bp = getBreakpoint();
        var saved = localStorage.getItem('fvs_grid_cols_' + bp);
        return saved || gridDefaults[bp];
      }

      function applyGrid(cols) {
        collectionGrid.style.setProperty('grid-template-columns', 'repeat(' + cols + ', 1fr)');
        var visibleBtns = gridToggle.querySelectorAll('[data-grid-cols]');
        visibleBtns.forEach(function(b) {
          b.classList.toggle('grid-toggle__btn--active', b.getAttribute('data-grid-cols') === cols);
        });
      }

      applyGrid(getDefaultCols());

      gridToggle.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-grid-cols]');
        if (!btn) return;
        var cols = btn.getAttribute('data-grid-cols');
        applyGrid(cols);
        localStorage.setItem(getStorageKey(), cols);
      });

      var resizeGridTimer = null;
      window.addEventListener('resize', function() {
        clearTimeout(resizeGridTimer);
        resizeGridTimer = setTimeout(function() {
          applyGrid(getDefaultCols());
        }, 200);
      }, { passive: true });
    }

    /* ── Description clamp ── */
    var descWrap = document.querySelector('[data-desc-clamp]');
    if (descWrap) {
      var descText = descWrap.querySelector('.collection-banner__desc-text');
      var descToggle = descWrap.querySelector('[data-desc-toggle]');
      if (descText && descText.scrollHeight > descText.clientHeight + 2) {
        descWrap.classList.add('has-overflow');
      }
      if (descToggle) {
        descToggle.addEventListener('click', function() {
          var expanded = descWrap.classList.toggle('is-expanded');
          descToggle.textContent = expanded ? 'Read less' : 'Read more';
        });
      }
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var wraps = document.querySelectorAll('[data-scroll-row]');
    wraps.forEach(function(wrap) {
      var row = wrap.querySelector('.list-collections__row');
      if (!row) return;

      function updateArrows() {
        var sl = row.scrollLeft;
        var maxScroll = row.scrollWidth - row.clientWidth;
        wrap.classList.toggle('can-scroll-left', sl > 4);
        wrap.classList.toggle('can-scroll-right', sl < maxScroll - 4);
      }

      row.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();

      var leftBtn = wrap.querySelector('[data-scroll-left]');
      var rightBtn = wrap.querySelector('[data-scroll-right]');
      var scrollAmt = row.clientWidth * 0.7;

      if (leftBtn) leftBtn.addEventListener('click', function() {
        row.scrollBy({ left: -scrollAmt, behavior: 'smooth' });
      });
      if (rightBtn) rightBtn.addEventListener('click', function() {
        row.scrollBy({ left: scrollAmt, behavior: 'smooth' });
      });

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(updateArrows).observe(row);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
  (function() {
    var grid = document.getElementById('wl-grid');
    var empty = document.getElementById('wl-empty');
    var countEl = document.getElementById('wl-page-count');
    if (!grid) return;

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function esc(str) {
      return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    }

    function buildCard(data) {
      var card = document.createElement('div');
      card.className = 'wl-card';
      card.setAttribute('data-wl-card', data.handle);

      var badgeHtml = '';
      if (!data.available) {
        badgeHtml = '<span class="wl-card__badge wl-card__badge--soldout">Sold Out</span>';
      } else if (data.comparePrice && data.comparePrice > data.price) {
        badgeHtml = '<span class="wl-card__badge wl-card__badge--sale">Sale</span>';
      }

      var priceHtml = '';
      if (data.price) {
        if (data.comparePrice && data.comparePrice > data.price) {
          priceHtml += '<span class="wl-card__price-compare">' + formatMoney(data.comparePrice) + '</span>';
        }
        priceHtml += '<span>' + formatMoney(data.price) + '</span>';
        if (data.rateUnit) {
          priceHtml += '<span class="wl-card__price-unit">/ ' + esc(data.rateUnit) + '</span>';
        }
      }

      var atcHtml = '';
      if (data.available && data.variantId) {
        atcHtml = '<button type="button" class="wl-card__atc" data-wl-atc="' + data.variantId + '" aria-label="Add to cart">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
          '</button>';
      }

      card.innerHTML =
        '<a href="/products/' + data.handle + '" class="wl-card__link">' +
          '<div class="wl-card__media">' +
            (data.img
              ? '<img class="wl-card__img" src="' + data.img + '" alt="' + esc(data.title) + '" loading="lazy">'
              : '<div class="wl-card__placeholder">No image</div>') +
            badgeHtml +
            atcHtml +
          '</div>' +
          '<div class="wl-card__info">' +
            '<h3 class="wl-card__title">' + esc(data.title || data.handle) + '</h3>' +
            '<div class="wl-card__row">' +
              (data.meta ? '<p class="wl-card__meta" style="text-transform:capitalize;">' + esc(data.meta) + '</p>' : '') +
              '<div class="wl-card__price">' + priceHtml + '</div>' +
            '</div>' +
          '</div>' +
        '</a>' +
        '<button type="button" class="wl-card__remove" data-wl-remove="' + data.handle + '" aria-label="Remove from wishlist">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="#e25555" stroke="#e25555" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>' +
        '</button>';

      return card;
    }

    function loadingCard(handle) {
      var card = document.createElement('div');
      card.className = 'wl-card';
      card.setAttribute('data-wl-card', handle);
      card.innerHTML =
        '<div class="wl-card__link">' +
          '<div class="wl-card__media"><div class="wl-card__placeholder">Loading...</div></div>' +
          '<div class="wl-card__info"><h3 class="wl-card__title">Loading...</h3></div>' +
        '</div>' +
        '<button type="button" class="wl-card__remove" data-wl-remove="' + handle + '" aria-label="Remove">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="#e25555" stroke="#e25555" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>' +
        '</button>';
      return card;
    }

    function splitCamelCase(str) {
      if (!str) return '';
      return str.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    }

    function fetchProduct(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function(r) {
          if (!r.ok) throw new Error('Not found');
          return r.json();
        })
        .then(function(product) {
          var firstAvail = product.variants.find(function(v) { return v.available; }) || product.variants[0];
          var meta = '';
          if (product.metafields && product.metafields['mm-google-shopping']) {
            meta = product.metafields['mm-google-shopping'].material || product.metafields['mm-google-shopping'].custom_label_0 || '';
          }
          var rateUnit = '';
          if (product.metafields && product.metafields.custom && product.metafields.custom.rate_unit) {
            rateUnit = product.metafields.custom.rate_unit;
          }

          var tagMeta = '';
          product.tags.forEach(function(tag) {
            if (!tagMeta && tag.indexOf('material:') === 0) tagMeta = tag.split(':')[1];
          });

          return {
            handle: handle,
            title: product.title,
            img: product.featured_image ? product.featured_image.replace(/(\.[^.]+)$/, '_600x$1') : '',
            price: firstAvail ? firstAvail.price : product.price,
            comparePrice: firstAvail ? firstAvail.compare_at_price : product.compare_at_price,
            available: product.available,
            variantId: firstAvail ? firstAvail.id : null,
            meta: meta ? splitCamelCase(meta) : tagMeta,
            rateUnit: rateUnit
          };
        })
        .catch(function() {
          return null;
        });
    }

    function renderWishlist() {
      var items = window.__wl ? window.__wl.get() : [];
      grid.innerHTML = '';

      if (items.length === 0) {
        grid.style.display = 'none';
        empty.style.display = '';
        countEl.textContent = '';
        return;
      }

      grid.style.display = '';
      empty.style.display = 'none';
      countEl.textContent = items.length + (items.length === 1 ? ' product' : ' products');

      items.forEach(function(item) {
        grid.appendChild(loadingCard(item.handle));
        fetchProduct(item.handle).then(function(data) {
          var placeholder = grid.querySelector('[data-wl-card="' + item.handle + '"]');
          if (!placeholder) return;
          if (data) {
            if (!data.meta && item.meta) data.meta = item.meta;
            if (!data.rateUnit && item.rateUnit) data.rateUnit = item.rateUnit;
            placeholder.replaceWith(buildCard(data));
          } else {
            if (window.__wl) window.__wl.remove(item.handle);
            placeholder.remove();
            var remaining = window.__wl ? window.__wl.get() : [];
            countEl.textContent = remaining.length + (remaining.length === 1 ? ' product' : ' products');
            if (remaining.length === 0) {
              grid.style.display = 'none';
              empty.style.display = '';
              countEl.textContent = '';
            }
          }
        });
      });
    }

    grid.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('[data-wl-remove]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        var handle = removeBtn.getAttribute('data-wl-remove');
        if (window.__wl) window.__wl.remove(handle);
        var card = removeBtn.closest('.wl-card');
        if (card) card.remove();
        var remaining = window.__wl ? window.__wl.get() : [];
        countEl.textContent = remaining.length + (remaining.length === 1 ? ' product' : ' products');
        if (remaining.length === 0) {
          grid.style.display = 'none';
          empty.style.display = '';
          countEl.textContent = '';
        }
        return;
      }

      var atcBtn = e.target.closest('[data-wl-atc]');
      if (atcBtn) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = atcBtn.getAttribute('data-wl-atc');
        atcBtn.classList.add('is-adding');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(function(r) {
          return r.json().then(function(data) {
            if (!r.ok) {
              var err = new Error((data && (data.description || data.message)) || 'Could not add to cart. Please try again.');
              err.cartError = true;
              throw err;
            }
            return data;
          });
        })
        .then(function() {
          var cartIcon = document.querySelector('.header__cart-btn');
          var cardImg = atcBtn.closest('.wl-card__media').querySelector('.wl-card__img');
          if (window.__flyTo && cartIcon) {
            var flyImg = cardImg ? cardImg.src : '';
            window.__flyTo(atcBtn, cartIcon, flyImg);
          }
          atcBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
          if (window.__cartAdded) window.__cartAdded();
          setTimeout(function() {
            atcBtn.classList.remove('is-adding');
            atcBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
          }, 1500);
        })
        .catch(function(err) {
          atcBtn.classList.remove('is-adding');
          var toast = document.getElementById('wl-toast');
          if (toast) {
            toast.textContent = err && err.cartError ? err.message : 'Could not add to cart. Please try again.';
            toast.classList.add('is-visible');
            clearTimeout(toast._timer);
            toast._timer = setTimeout(function() { toast.classList.remove('is-visible'); }, 3000);
          }
        });
        return;
      }
    });

    var checkReady = setInterval(function() {
      if (window.__wl) {
        clearInterval(checkReady);
        renderWishlist();
      }
    }, 50);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-coupons"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.coupon-card__copy').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var code = this.dataset.copy;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        this.classList.add('is-copied');
        this.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>';
        var self = this;
        setTimeout(function() {
          self.classList.remove('is-copied');
          self.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>';
        }, 2000);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quantity-presets"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var cards = document.querySelectorAll('.qty-preset-card');
    var meterInput = document.getElementById('meter-input');

    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        var meters = parseInt(this.dataset.meters);
        if (meterInput && meters) {
          meterInput.value = meters;
          meterInput.dispatchEvent(new Event('change'));
        }
        cards.forEach(function(c) { c.classList.remove('is-selected'); });
        this.classList.add('is-selected');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.product-reco').forEach(function(section) {
      var url = section.dataset.url;
      if (!url) return;
      if (section.querySelector('.product-card')) {
        initNav(section);
        return;
      }
      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.product-reco');
          if (fresh && fresh.innerHTML.trim().length > 0) {
            section.innerHTML = fresh.innerHTML;
            initNav(section);
          }
        });
    });

    function initNav(section) {
      var track = section.querySelector('.product-reco__track');
      var prev = section.querySelector('.product-reco__arrow--prev');
      var next = section.querySelector('.product-reco__arrow--next');
      if (!track || !prev || !next) return;

      function updateArrows() {
        prev.disabled = track.scrollLeft < 10;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
      }

      var card = track.querySelector('.product-card');
      var step = card ? card.offsetWidth + 16 : 300;

      prev.addEventListener('click', function() { track.scrollBy({ left: -step * 2, behavior: 'smooth' }); });
      next.addEventListener('click', function() { track.scrollBy({ left: step * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var tracks = document.querySelectorAll('[data-pr-track]');
    tracks.forEach(function(track) {
      var cards = track.querySelectorAll('.pr-card');
      if (cards.length < 2) return;
      var half = cards.length / 2;
      var totalWidth = 0;
      for (var i = 0; i < half; i++) {
        totalWidth += cards[i].offsetWidth + 12;
      }
      var speed = 40;
      var duration = totalWidth / speed;
      track.style.setProperty('--pr-scroll-duration', duration + 's');
      track.classList.add('is-scrolling');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-promo-countdown]').forEach(function(el) {
      var end = new Date(el.dataset.end).getTime();
      var timer = el.querySelector('[data-promo-timer]');
      if (!timer || isNaN(end)) return;

      var daysEl = timer.querySelector('[data-days]');
      var hrsEl = timer.querySelector('[data-hours]');
      var minsEl = timer.querySelector('[data-mins]');
      var secsEl = timer.querySelector('[data-secs]');

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var diff = Math.max(0, end - Date.now());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        daysEl.textContent = pad(d);
        hrsEl.textContent = pad(h);
        minsEl.textContent = pad(m);
        secsEl.textContent = pad(s);
        if (diff <= 0) {
          clearInterval(interval);
          el.style.display = 'none';
        }
      }

      tick();
      var interval = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reach-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.reach-form-section');
    if (!section) return;

    var SID         = section.dataset.sectionId;
    var API_URL     = section.dataset.apiUrl;
    var RESP_TIME   = section.dataset.responseTime;
    var BTN_TEXT    = section.dataset.btnText;
    var SHOW_ORDER  = section.dataset.showOrder === 'true';
    var SHOW_PHONE  = section.dataset.showPhone === 'true';

    var SUBCATS = {
      order_issue: [
        { value: 'tracking',       label: 'Tracking / Shipping Delay' },
        { value: 'wrong_item',     label: 'Wrong Item Received' },
        { value: 'missing_item',   label: 'Missing Item in Order' },
        { value: 'not_delivered',  label: 'Order Not Delivered' }
      ],
      refund_inquiry: [
        { value: 'return_request', label: 'Return Request' },
        { value: 'exchange',       label: 'Exchange Request' },
        { value: 'refund_status',  label: 'Refund Status' }
      ],
      wholesale: [
        { value: 'bulk_order',     label: 'Bulk Order Query' },
        { value: 'partnership',    label: 'Partnership / Reseller' },
        { value: 'moq_pricing',    label: 'MOQ & Pricing' },
        { value: 'samples',        label: 'Sample Request' },
        { value: 'customization',  label: 'Customization' }
      ],
      product_quality: [
        { value: 'sizing',         label: 'Sizing & Measurements' },
        { value: 'fabric_material',label: 'Fabric & Materials' },
        { value: 'availability',   label: 'Availability & Stock' }
      ],
      general: [
        { value: 'feedback',       label: 'General Feedback' },
        { value: 'website_issue',  label: 'Website Issue' },
        { value: 'design_gallery', label: 'Design Gallery' },
        { value: 'other',          label: 'Something Else' }
      ]
    };

    var ORDER_CATS = ['order_issue', 'refund_inquiry'];

    var form       = document.getElementById('reach-form-' + SID);
    var subcatWrap = form.querySelector('.reach-form__subcat-wrap');
    var subcatsEl  = form.querySelector('.reach-form__subcats');
    var fieldsWrap = form.querySelector('.reach-form__fields');
    var btn        = form.querySelector('.reach-form__btn');
    var btnText    = btn.querySelector('.reach-form__btn-text');
    var btnSpin    = btn.querySelector('.reach-form__btn-spinner');
    var apiErrEl   = form.querySelector('.reach-form__api-err');
    var rateMsg    = form.querySelector('.reach-form__rate-msg');
    var successEl  = form.querySelector('.reach-form__success');
    var successMsg = form.querySelector('.reach-form__success-msg');
    var orderRow   = form.querySelector('.reach-form__order-row');

    function errEl(name) { return form.querySelector('[data-err="' + name + '"]'); }

    var selectedCat = null;
    var selectedSubcat = null;
    var lastSubmit = 0;
    var RATE_LIMIT = 30000;

    var params = new URLSearchParams(window.location.search);
    var catMap = { order: 'order_issue', returns: 'refund_inquiry', wholesale: 'wholesale', product: 'product_quality', other: 'general' };
    var paramCat = params.get('category');
    if (paramCat && catMap[paramCat]) selectCategory(catMap[paramCat]);

    var paramOrder = params.get('order_number');
    if (paramOrder && SHOW_ORDER) {
      var oi = document.getElementById('reach-order-' + SID);
      if (oi) oi.value = paramOrder.replace(/^#/, '');
    }

    var paramEmail = params.get('email');
    if (paramEmail) {
      var ei = document.getElementById('reach-email-' + SID);
      if (ei) ei.value = paramEmail;
    }

    var catLabels = form.querySelectorAll('.reach-form__cat');
    catLabels.forEach(function(label) {
      label.addEventListener('click', function() { selectCategory(label.dataset.value); });
      label.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCategory(label.dataset.value); }
      });
    });

    function selectCategory(val) {
      selectedCat = val;
      selectedSubcat = null;
      catLabels.forEach(function(l) { l.classList.remove('is-selected'); });
      var target = form.querySelector('.reach-form__cat[data-value="' + val + '"]');
      if (target) {
        target.classList.add('is-selected');
        target.querySelector('input[type="radio"]').checked = true;
      }
      errEl('cat').textContent = '';

      if (SHOW_ORDER && orderRow) {
        orderRow.hidden = true;
        var oi = document.getElementById('reach-order-' + SID);
        if (oi) { oi.required = false; oi.value = ''; oi.classList.remove('is-invalid'); }
        var oe = errEl('orderNumber');
        if (oe) oe.textContent = '';
      }

      buildSubcats(val);
      subcatWrap.hidden = false;
      fieldsWrap.hidden = true;
      errEl('subcat').textContent = '';
    }

    function buildSubcats(catVal) {
      var items = SUBCATS[catVal] || [];
      subcatsEl.innerHTML = '';
      items.forEach(function(item) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'reach-form__subcat';
        b.dataset.value = item.value;
        b.textContent = item.label;
        b.addEventListener('click', function() { selectSubcat(item.value, b); });
        subcatsEl.appendChild(b);
      });
    }

    function selectSubcat(val, el) {
      selectedSubcat = val;
      subcatsEl.querySelectorAll('.reach-form__subcat').forEach(function(b) { b.classList.remove('is-selected'); });
      el.classList.add('is-selected');
      errEl('subcat').textContent = '';

      if (SHOW_ORDER && orderRow) {
        var needsOrder = ORDER_CATS.indexOf(selectedCat) !== -1;
        orderRow.hidden = !needsOrder;
        var oi = document.getElementById('reach-order-' + SID);
        if (oi) oi.required = needsOrder;
      }

      fieldsWrap.hidden = false;

      var placeholders = {
        tracking: 'Please share your order number and describe the shipping issue...',
        wrong_item: 'Please describe what item you received vs. what you ordered...',
        missing_item: 'Please list which items were missing from your order...',
        not_delivered: 'Please share your order number and delivery address...',
        return_request: 'Please share your order number and reason for return...',
        exchange: 'Please share what you\'d like to exchange for...',
        refund_status: 'Please share your order number to check refund status...',
        bulk_order: 'Please describe the fabric, quantity, and timeline needed...',
        partnership: 'Tell us about your business and what you\'re looking for...',
        moq_pricing: 'Which fabrics are you interested in? What quantities?',
        samples: 'Which fabrics would you like samples of?',
        sizing: 'Which product? What sizing info do you need?',
        fabric_material: 'Which fabric/product are you asking about?',
        availability: 'Which product are you looking for?',
        customization: 'Describe your customization requirements...',
        feedback: 'Share your feedback or suggestion...',
        website_issue: 'Describe the issue and which page...',
        design_gallery: 'Which design are you asking about?',
        other: 'Describe your question or concern...'
      };
      var msgEl = document.getElementById('reach-msg-' + SID);
      if (msgEl) msgEl.placeholder = placeholders[val] || 'Describe your question or concern...';
    }

    function validateField(input) {
      var e = errEl(input.name);
      if (e) e.textContent = '';
      input.classList.remove('is-invalid');
      if (input.required && !input.value.trim()) {
        if (e) e.textContent = 'This field is required.';
        input.classList.add('is-invalid');
        return false;
      }
      if (input.type === 'email' && input.value.trim()) {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim())) {
          if (e) e.textContent = 'Enter a valid email address.';
          input.classList.add('is-invalid');
          return false;
        }
      }
      return true;
    }

    form.querySelectorAll('.reach-form__input').forEach(function(input) {
      input.addEventListener('blur', function() { validateField(input); });
      input.addEventListener('input', function() {
        input.classList.remove('is-invalid');
        var e = errEl(input.name);
        if (e) e.textContent = '';
      });
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var hp = form.querySelector('[name="fvs_hp"]');
      if (hp && hp.value) return;

      var now = Date.now();
      if (now - lastSubmit < RATE_LIMIT) {
        var wait = Math.ceil((RATE_LIMIT - (now - lastSubmit)) / 1000);
        rateMsg.textContent = 'Please wait ' + wait + 's before submitting again.';
        rateMsg.hidden = false;
        return;
      }
      rateMsg.hidden = true;

      if (!selectedCat) {
        errEl('cat').textContent = 'Please select a category.';
        return;
      }
      if (!selectedSubcat) {
        errEl('subcat').textContent = 'Please select a specific topic.';
        return;
      }

      var valid = true;
      form.querySelectorAll('.reach-form__input').forEach(function(input) {
        if (!validateField(input)) valid = false;
      });
      if (!valid) {
        var first = form.querySelector('.is-invalid');
        if (first) first.focus();
        return;
      }

      var payload = {
        category: selectedCat,
        subCategory: selectedSubcat,
        name: (document.getElementById('reach-name-' + SID) || {}).value || '',
        email: (document.getElementById('reach-email-' + SID) || {}).value || '',
        phone: (document.getElementById('reach-phone-' + SID) || {}).value || '',
        orderNumber: (document.getElementById('reach-order-' + SID) || {}).value || '',
        message: (document.getElementById('reach-msg-' + SID) || {}).value || ''
      };

      btn.disabled = true;
      btnText.textContent = 'Sending...';
      btnSpin.hidden = false;
      apiErrEl.hidden = true;

      if (!API_URL) {
        lastSubmit = Date.now();
        showSuccess(payload.email, 'DEMO-TICKET');
        return;
      }

      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        return res.json().then(function(data) { return { ok: res.ok, data: data }; });
      })
      .then(function(result) {
        if (result.ok && result.data.success) {
          lastSubmit = Date.now();
          showSuccess(payload.email, result.data.ticketNumber);
        } else {
          throw new Error(result.data.message || 'Something went wrong. Please try again.');
        }
      })
      .catch(function(err) {
        apiErrEl.textContent = err.message || 'Network error. Please try again.';
        apiErrEl.hidden = false;
        btn.disabled = false;
        btnText.textContent = BTN_TEXT;
        btnSpin.hidden = true;
      });
    });

    function showSuccess(email, ticketNumber) {
      btn.disabled = false;
      btnText.textContent = BTN_TEXT;
      btnSpin.hidden = true;
      successEl.hidden = false;
      var ticket = ticketNumber ? ' Your ticket number is <strong>' + ticketNumber + '</strong>.' : '';
      successMsg.innerHTML = 'Thank you! We\'ve received your message and will get back to you ' + RESP_TIME + '.' + ticket + ' A confirmation has been sent to <strong>' + esc(email) + '</strong>.';
      successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function esc(s) {
      return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var KEY = 'fvs_recently_viewed';
    var MAX = 20;

    var section = document.querySelector('.recently-viewed');
    if (!section) return;

    var currentUrl = section.dataset.productUrl;
    var sectionId = section.dataset.sectionId;

    if (currentUrl) {
      var items = [];
      try { items = JSON.parse(localStorage.getItem(KEY)) || []; } catch(e) { items = []; }
      items = items.filter(function(u) { return u !== currentUrl; });
      items.unshift(currentUrl);
      if (items.length > MAX) items = items.slice(0, MAX);
      try { localStorage.setItem(KEY, JSON.stringify(items)); } catch(e) {}
    }

    var stored = [];
    try { stored = JSON.parse(localStorage.getItem(KEY)) || []; } catch(e) { stored = []; }
    var display = stored.filter(function(u) { return u !== currentUrl; }).slice(0, 10);
    if (display.length < 2) return;

    var track = section.querySelector('.recently-viewed__track');
    if (!track) return;

    var loaded = 0;
    var total = display.length;

    display.forEach(function(productUrl) {
      fetch(productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var card = temp.querySelector('.product-card');
          if (card) {
            card.dataset.rvOrder = display.indexOf(productUrl);
            track.appendChild(card);
          }
          loaded++;
          if (loaded === total) {
            var cards = Array.from(track.children);
            cards.sort(function(a, b) { return (a.dataset.rvOrder || 0) - (b.dataset.rvOrder || 0); });
            cards.forEach(function(c) { track.appendChild(c); });
            if (track.children.length >= 2) {
              section.style.display = '';
            }
            track.querySelectorAll('.product-card__quick-view').forEach(function(btn) {
              btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                var handle = btn.getAttribute('data-product-url').split('/products/')[1].split('?')[0];
                var cardImg = btn.closest('.product-card__media').querySelector('.product-card__img--primary');
                var imgSrc = cardImg ? cardImg.src : '';
                var extraData = {
                  meta: btn.getAttribute('data-card-meta') || '',
                  reviewAvg: parseInt(btn.getAttribute('data-review-avg')) || 0,
                  reviewCount: parseInt(btn.getAttribute('data-review-count')) || 0,
                  rateUnit: btn.getAttribute('data-rate-unit') || ''
                };
                if (window.__qvOpen) {
                  window.__qvOpen(handle, imgSrc, extraData);
                } else {
                  window.location.href = btn.getAttribute('data-product-url');
                }
              });
            });
          }
        })
        .catch(function() {
          loaded++;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var faqItems = document.querySelectorAll('[data-ws-faq-toggle]');
    faqItems.forEach(function(btn) {
      btn.addEventListener('click', function() {
        btn.closest('.wholesale__faq-item').classList.toggle('is-open');
      });
    });

    var anchor = document.querySelector('.wholesale__hero-cta');
    if (anchor) {
      anchor.addEventListener('click', function(e) {
        var target = document.querySelector(anchor.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    var ctaBtn = document.querySelector('.wholesale__cta-btn--primary');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function(e) {
        var target = document.querySelector(ctaBtn.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    var perkDescriptions = {};
    document.querySelectorAll('[data-perk-detail-key]').forEach(function(item) {
      var key = item.getAttribute('data-perk-detail-key');
      var text = item.querySelector('.wholesale__perk-detail-text');
      if (key && text) perkDescriptions[key] = text.textContent.trim();
    });

    function findDesc(key) {
      if (perkDescriptions[key]) return perkDescriptions[key];
      var keys = Object.keys(perkDescriptions);
      for (var i = 0; i < keys.length; i++) {
        if (key.indexOf(keys[i]) !== -1 || keys[i].indexOf(key) !== -1) return perkDescriptions[keys[i]];
      }
      return null;
    }

    document.querySelectorAll('[data-perk-tooltip]').forEach(function(btn) {
      var chip = btn.closest('.wholesale__perk-chip');
      if (!chip) return;
      var key = chip.getAttribute('data-perk-key');
      var desc = findDesc(key);
      if (!desc) return;

      var tooltip = null;

      function showTip() {
        if (tooltip) return;
        tooltip = document.createElement('div');
        tooltip.className = 'wholesale__perk-tooltip';
        tooltip.textContent = desc;
        chip.appendChild(tooltip);
      }

      function hideTip() {
        if (tooltip) {
          tooltip.remove();
          tooltip = null;
        }
      }

      btn.addEventListener('mouseenter', showTip);
      btn.addEventListener('mouseleave', hideTip);
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (tooltip) { hideTip(); } else { showTip(); }
      });
    });

    document.querySelectorAll('[data-offer-tip]').forEach(function(btn) {
      var wrap = btn.closest('.wholesale__offer-badge-wrap');
      var desc = btn.getAttribute('data-offer-tip');
      if (!wrap || !desc) return;
      var tip = null;
      function show() {
        if (tip) return;
        tip = document.createElement('div');
        tip.className = 'wholesale__perk-tooltip';
        tip.textContent = desc;
        wrap.appendChild(tip);
      }
      function hide() { if (tip) { tip.remove(); tip = null; } }
      btn.addEventListener('mouseenter', show);
      btn.addEventListener('mouseleave', hide);
      btn.addEventListener('click', function(e) { e.stopPropagation(); if (tip) { hide(); } else { show(); } });
    });

    document.addEventListener('click', function() {
      document.querySelectorAll('.wholesale__perk-tooltip').forEach(function(t) { t.remove(); });
    });

    var detailsToggle = document.querySelector('[data-perk-details-toggle]');
    if (detailsToggle) {
      detailsToggle.addEventListener('click', function() {
        detailsToggle.closest('[data-perk-details]').classList.toggle('is-open');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
